import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import Loader from "react-loader-spinner"
import { confirmAlert } from "react-confirm-alert"
import { validateForm } from "../../../../../../services/validation"
import {
  saveRequiredServices,
  deleteRequiredServices,
  saveMyGoals
} from "../../../../../../services/plans"
import configs from "../../../../../../configs"

import Tooltip from "../../../../../../components/Tooltip"
import Repeater from "../../../../components/Repeater"
import RadioCard from "../../../../components/RadioCard"
import CheckboxCards from "../CheckboxCards"
import Form, {
  Group,
  Input,
  Checkbox,
  File,
  Select
} from "../../../../../../components/Form"
import Button from "../../../../../../components/Button"
import DayPicker from "../DayPicker"
import RequestSupport from "../../../../components/RequestSupport"

import OneOffPurchasesCard from "../../../../components/OneOffPurchasesCard"
import DailyOrWeeklyServicesCard from "../../../../components/DailyOrWeeklyServicesCard"
import RecurringActivitiesCard from "../../../../components/RecurringActivitiesCard"
import RecurringPurchasesCard from "../../../../components/RecurringPurchasesCard"

import iconWheelchair from "./images/icon-wheelchair.svg"
import iconWheelchairLight from "./images/icon-wheelchair-light.svg"
import iconHelp from "./images/icon-help.svg"
import iconHelpLight from "./images/icon-help-light.svg"
import iconHappiness from "./images/icon-happiness.svg"
import iconHappinessLight from "./images/icon-happiness-light.svg"
import iconTablets from "./images/icon-tablets.svg"
import iconTabletsLight from "./images/icon-tablets-light.svg"

class AddService extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeStep: 1,
      isSubmitted: false,
      formIsHidden: true,
      services: [],
      goals: [],
      form: {
        step1: {
          requiredService: {
            placeholder: "Your Required Service",
            name: "requiredService",
            type: "text",
            value: "",
            required: true
          }
        },
        step2: {
          bestFitsRequiredService: {
            name: "bestFitsRequiredService",
            type: "radio",
            value: "",
            options: [
              {
                title: "One Off Purchases",
                description:
                  "Select this option if you need to purchase technology, equipment or products for your personal care and safety. NDIS also provides funds for home and vehicle modifications that will  improve your quality of life.",
                value: "1",
                icon: iconWheelchair,
                iconLight: iconWheelchairLight,
                iconTitle: "Wheelchair"
              },
              {
                title: "Daily or Weekly Services",
                description:
                  "Select this option if you need a service that occurs regularly that will help you with your daily life and move you towards achieving your goals. This includes cleaning services and help around home. You can also request help with educational fees and activities, camps or vacations that will build your independence. NDIS will even assist with transport to these activities and work.",
                value: "2",
                icon: iconHelp,
                iconLight: iconHelpLight,
                iconTitle: "Help"
              },
              {
                title: "Recurring Activities",
                description:
                  "Select this option if you are requesting services that help build your independence and skills. this could look like mental health counselling, physiotherapy, recreational community activities, educational and employment related opportunities.",
                value: "3",
                icon: iconHappiness,
                iconLight: iconHappinessLight,
                iconTitle: "Happiness"
              },
              {
                title: "Recurring Purchases",
                description:
                  "Select this option if you need to regularly buy items for your health or require to improve your quality of life. this could look like medical supplies, bandages or medication.",
                value: "4",
                icon: iconTablets,
                iconLight: iconTabletsLight,
                iconTitle: "Tablets"
              }
            ],
            required: true
          }
        },
        step3_1: {
          lowGuess: {
            placeholder: "Low Guess",
            name: "lowGuess",
            type: "text",
            value: "",
            icon: "$",
            required: true
          },
          highGuess: {
            placeholder: "High Guess",
            name: "highGuess",
            type: "text",
            value: "",
            icon: "$",
            required: true
          },
          cost: {
            label: "I’m not sure how much it will cost",
            name: "cost",
            type: "checkbox",
            checked: false,
            value: "",
            required: false,
            class: ""
          },
          files: {
            label: "Upload Png or Pdf",
            description:
              "If you have any receipts, photos or documents of prices you can attach these to help get the funding you need.",
            accept: ".doc,.docx,.pdf,.csv,.xlsx,.png,.jpg,.jpeg",
            name: "files",
            type: "file",
            value: [],
            required: false
          }
        },
        step3_2: {
          daysService: {
            name: "daysService",
            value: [],
            required: true
          }
        },
        step3_3: {
          howOften: {
            placeholder: "0",
            name: "howOften",
            type: "text",
            value: "",
            required: true
          },
          timesPer: {
            placeholder: "Choose an option",
            name: "timesPer",
            value: "",
            options: [
              {
                value: "D",
                label: "Day"
              },
              {
                value: "W",
                label: "Week"
              },
              {
                value: "F",
                label: "Fortnight"
              },
              {
                value: "M",
                label: "Month"
              },
              {
                value: "Y",
                label: "Year"
              }
            ],
            required: true
          },
          howMuch: {
            name: "howMuch",
            type: "text",
            value: "",
            icon: "$",
            required: true
          },
          every: {
            placeholder: "Choose an option",
            name: "every",
            value: "",
            options: [
              {
                value: "D",
                label: "Day"
              },
              {
                value: "W",
                label: "Week"
              },
              {
                value: "F",
                label: "Fortnight"
              },
              {
                value: "M",
                label: "Month"
              },
              {
                value: "Y",
                label: "Year"
              }
            ],
            required: true
          },
          cost: {
            label: "I’m not sure how much it will cost",
            name: "cost",
            type: "checkbox",
            checked: false,
            value: "",
            required: false,
            class: ""
          },
          files: {
            label: "Upload Png or Pdf",
            description:
              "If you have any receipts, photos or documents of prices you can attach these to help get the funding you need.",
            accept: ".doc,.docx,.pdf,.csv,.xlsx,.png,.jpg,.jpeg",
            name: "files",
            type: "file",
            value: [],
            required: false
          }
        },
        step3_4: {
          howOften: {
            placeholder: "0",
            name: "howOften",
            type: "text",
            value: "",
            required: true
          },
          timesPer: {
            placeholder: "Choose an option",
            name: "timesPer",
            value: "",
            options: [
              {
                value: "D",
                label: "Day"
              },
              {
                value: "W",
                label: "Week"
              },
              {
                value: "F",
                label: "Fortnight"
              },
              {
                value: "M",
                label: "Month"
              },
              {
                value: "Y",
                label: "Year"
              }
            ],
            required: true
          },
          howMuch: {
            name: "howMuch",
            type: "text",
            value: "",
            icon: "$",
            required: true
          },
          every: {
            placeholder: "Choose an option",
            name: "every",
            value: "Fortnight",
            options: [
              {
                value: "D",
                label: "Day"
              },
              {
                value: "W",
                label: "Week"
              },
              {
                value: "F",
                label: "Fortnight"
              },
              {
                value: "M",
                label: "Month"
              },
              {
                value: "Y",
                label: "Year"
              }
            ],
            required: true
          },
          cost: {
            label: "I’m not sure how much it will cost",
            name: "cost",
            type: "checkbox",
            checked: false,
            value: "",
            required: false,
            class: ""
          },
          files: {
            label: "Upload Png or Pdf",
            description:
              "If you have any receipts, photos or documents of prices you can attach these to help get the funding you need.",
            accept: ".doc,.docx,.pdf,.csv,.xlsx,.png,.jpg,.jpeg",
            name: "files",
            type: "file",
            value: [],
            required: false
          }
        },
        step4: {
          goals: {
            name: "goals",
            value: []
          }
        }
      },
      requestSupportIsHidden: true
    }
  }

  componentDidMount() {
    this.updateServices()

    this.updateGoals()
  }

  componentDidUpdate(prevProps) {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.requiredServices) {
      if (
        JSON.stringify(prevProps.store.plan.answers.requiredServices) !==
        JSON.stringify(plan.answers.requiredServices)
      ) {
        this.updateServices()
      }
    }

    if (plan.answers.myGoals) {
      if (
        JSON.stringify(prevProps.store.plan.answers.myGoals) !==
        JSON.stringify(plan.answers.myGoals)
      ) {
        this.updateGoals()
      }
    }
  }

  requestSupportToggle = () => {
    const { requestSupportIsHidden } = this.state

    this.setState({ requestSupportIsHidden: !requestSupportIsHidden })
  }

  updateGoals = () => {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.myGoals) {
      this.setState({
        goals: plan.answers.myGoals.goal
      })
    }
  }

  updateServices = () => {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.requiredServices) {
      const services = []

      plan.answers.requiredServices.map(requiredService => {
        const key = Object.keys(requiredService)[0]

        requiredService[key].map(requiredServiceInner => {
          services.push(requiredServiceInner)

          return null
        })

        return null
      })

      this.setState(
        {
          services
        },
        () => {
          this.openFormByUrlParameter()
        }
      )
    }
  }

  openFormByUrlParameter = () => {
    const { id, history } = this.props
    const { services } = this.state

    if (id !== undefined) {
      services.map(item => {
        if (id === item.id) {
          history.push("/pre-plan/add-a-service")
          this.onFormOpen(null, item.id, 3, item)
        }

        return null
      })
    }
  }

  scrollToInvalidElement = fields => {
    Object.keys(fields).map((resKey, index) => {
      if (fields[resKey].message && index === 0) {
        let item
        let parent

        if (resKey === "daysService") {
          if (this.form.querySelector(".is-invalid")) {
            parent = this.form
              .querySelector(".is-invalid")
              .closest(".day-picker_times_row")
          } else {
            parent = this.form.querySelector(".day-picker_days")
          }
        } else {
          item = this.form.elements[resKey]
          parent = item.closest
            ? item.closest(".form_group")
            : item[0].closest(".form_group")
        }

        const offSet = parent.getBoundingClientRect().top + window.pageYOffset
        const supportsNativeSmoothScroll =
          "scrollBehavior" in document.documentElement.style

        if (supportsNativeSmoothScroll) {
          window.scrollTo({
            top: offSet,
            behavior: "smooth"
          })
        } else {
          window.scrollTo(0, offSet)
        }
      }

      return null
    })
  }

  getActiveStepName = () => {
    const { form, activeStep } = this.state

    if (activeStep === 3) {
      return `step${activeStep}_${form.step2.bestFitsRequiredService.value}`
    }
    return `step${activeStep}`
  }

  handleNext = () => {
    const { form, activeStep } = this.state
    const {
      scrollToNav,
      store: { user }
    } = this.props

    if (user.list_role.includes(configs.roles.Guardian)) {
      if (activeStep === 4) {
        this.setState({
          formIsHidden: true,
          isSubmitted: false,
          activeStep: 1
        })
      } else {
        this.setState({
          activeStep: activeStep + 1
        })
      }

      return
    }

    let step

    if (activeStep === 3) {
      step = `step${activeStep}_${form.step2.bestFitsRequiredService.value}`
    } else {
      step = `step${activeStep}`
    }

    const fields = form[step]

    if (step === "step3_1") {
      fields.lowGuess.required = !fields.cost.checked
      fields.highGuess.required = !fields.cost.checked
    } else if (step === "step3_3" || step === "step3_4") {
      fields.howMuch.required = !fields.cost.checked
      fields.every.required = !fields.cost.checked
    }

    if (step === "step3_1" || step === "step3_3" || step === "step3_4") {
      this.setState({
        form: {
          ...form,
          [step]: {
            ...fields
          }
        }
      })
    }

    const res = validateForm(fields)

    if (Object.keys(res).length === 0 && res.constructor === Object) {
      setTimeout(() => {
        scrollToNav()
      }, 100)

      if (activeStep === 4) {
        this.changeItem()
      } else {
        this.setState({
          isSubmitted: false,
          activeStep: activeStep + 1
        })
      }
    } else {
      this.scrollToInvalidElement(res)

      this.setState({
        isSubmitted: true,
        form: {
          ...form,
          [step]: {
            ...form[step],
            ...res
          }
        }
      })
    }
  }

  handleBack = () => {
    const { activeStep } = this.state
    const { scrollToNav } = this.props

    scrollToNav()

    if (activeStep === 1) {
      this.setState({
        formIsHidden: true,
        isSubmitted: false,
        requestSupportIsHidden: true
      })
    } else {
      this.setState({ activeStep: activeStep - 1 })
    }
  }

  getItem = () => {
    const { form } = this.state
    const newService = {
      title: "",
      description: "",
      goals: [],
      item_type: "",
      funding_group_id: 0,
      documents: [],
      item: [],
      items: []
    }
    const typesArr = [
      "one_off_purchase",
      "weekly_activity",
      "recurring_activity",
      "recurring_purchase"
    ]
    const type = form.step2.bestFitsRequiredService.value
    const goals = []

    form.step4.goals.value.map(goal => {
      if (goal.checked) {
        goals.push({ id: goal.id })
      }

      return null
    })

    newService.title = form.step1.requiredService.value
    newService.item_type = typesArr[type - 1]
    newService.goals = goals

    if (+type === 1) {
      newService.item = {}
      newService.item.lower = form.step3_1.lowGuess.value
      newService.item.upper = form.step3_1.highGuess.value
      newService.item.unknown_price = form.step3_1.cost.checked
      newService.documents = form.step3_1.files.value
      newService.funding_group_id = 1
    } else if (+type === 2) {
      const items = form.step3_2.daysService.value
      newService.items = Object.keys(items).map(key => {
        const newItem = {
          comment: "",
          day: items[key].value.day.value,
          end_time: items[key].value.end_time.value,
          end_time_period: items[key].value.end_time_period.value,
          num_hours: items[key].value.num_hours.value,
          start_time: items[key].value.start_time.value,
          start_time_period: items[key].value.start_time_period.value
        }

        return newItem
      })
      newService.funding_group_id = 3
    } else if (+type === 3) {
      newService.item = {}
      newService.item.num_required = form.step3_3.howOften.value
      newService.item.num_required_period = form.step3_3.timesPer.value
      newService.item.cost_required = form.step3_3.howMuch.value
      newService.item.cost_required_period = form.step3_3.every.value
      newService.item.unknown = form.step3_3.cost.checked
      newService.documents = form.step3_3.files.value
      newService.funding_group_id = 4
    } else if (+type === 4) {
      newService.item = {}
      newService.item.num_required = form.step3_4.howOften.value
      newService.item.num_required_period = form.step3_4.timesPer.value
      newService.item.cost_required = form.step3_4.howMuch.value
      newService.item.cost_required_period = form.step3_4.every.value
      newService.item.unknown = form.step3_4.cost.checked
      newService.documents = form.step3_4.files.value
      newService.funding_group_id = 2
    }

    return newService
  }

  changeItem = () => {
    const { currentId } = this.state
    const {
      onSaveRequiredServices,
      store: { user, plan }
    } = this.props

    const newItem = this.getItem(currentId)

    onSaveRequiredServices(
      user.token,
      plan.id,
      newItem,
      currentId ? "edit" : "add",
      currentId
    ).then(() => {
      this.setState({
        formIsHidden: true,
        isSubmitted: false,
        activeStep: 1
      })
    })
  }

  onFormOpen = (e, index, step, item) => {
    if (e) e.preventDefault()

    const { services, goals, form } = this.state
    const { scrollToNav } = this.props
    let currentId
    const newForm = form
    let res

    const clearForm = () => {
      newForm.step1.requiredService.value = ""
      newForm.step2.bestFitsRequiredService.value = ""

      newForm.step3_1.lowGuess.value = ""
      newForm.step3_1.highGuess.value = ""
      newForm.step3_1.cost.checked = false
      newForm.step3_1.files.value = []

      newForm.step3_2.daysService.value = []

      newForm.step3_3.howOften.value = ""
      newForm.step3_3.timesPer.value = ""
      newForm.step3_3.howMuch.value = ""
      newForm.step3_3.every.value = ""
      newForm.step3_3.cost.checked = false
      newForm.step3_3.files.value = []

      newForm.step3_4.howOften.value = ""
      newForm.step3_4.timesPer.value = ""
      newForm.step3_4.howMuch.value = ""
      newForm.step3_4.every.value = ""
      newForm.step3_4.cost.checked = false
      newForm.step3_4.files.value = []

      newForm.step4.goals.value = goals.map(goal => {
        const newGoal = {
          title: goal.title,
          description: goal.content,
          name: `goal${goal.id}`,
          id: goal.id,
          checked: false
        }

        return newGoal
      })
    }

    clearForm()

    scrollToNav()

    if (item) {
      currentId = index
      res = item
    } else if (index) {
      currentId = index
      res = services.find(({ id }) => {
        return index === id
      })
    } else {
      currentId = null
    }

    if (step) {
      this.setState({ activeStep: step })
    }

    if (res) {
      newForm.step1.requiredService.value = res.title

      if (res.item_type === "one_off_purchase") {
        newForm.step2.bestFitsRequiredService.value = "1"
        newForm.step3_1.lowGuess.value = res.item.lower
        newForm.step3_1.highGuess.value = res.item.upper
        newForm.step3_1.cost.checked = res.item.unknown_price
        newForm.step3_1.files.value = res.documents
      } else if (res.item_type === "weekly_activity") {
        newForm.step2.bestFitsRequiredService.value = "2"
        newForm.step3_2.daysService.value = res.items.map(day => {
          const newDay = {
            checked: true,
            value: {
              day: {
                name: "day",
                value: day.day,
                message: ""
              },
              end_time: {
                name: "end_time",
                value: day.end_time,
                message: ""
              },
              end_time_period: {
                name: "end_time_period",
                value: day.end_time_period,
                message: ""
              },
              num_hours: {
                name: "num_hours",
                value: day.num_hours,
                message: ""
              },
              start_time: {
                name: "start_time",
                value: day.start_time,
                message: ""
              },
              start_time_period: {
                name: "start_time_period",
                value: day.start_time_period,
                message: ""
              }
            }
          }

          return newDay
        })
      } else if (res.item_type === "recurring_activity") {
        newForm.step2.bestFitsRequiredService.value = "3"
        newForm.step3_3.howOften.value = res.item.num_required
        newForm.step3_3.timesPer.value = res.item.num_required_period
        newForm.step3_3.howMuch.value = res.item.cost_required
        newForm.step3_3.every.value = res.item.cost_required_period
        newForm.step3_3.cost.checked = res.item.unknown
        newForm.step3_3.files.value = res.documents
      } else if (res.item_type === "recurring_purchase") {
        newForm.step2.bestFitsRequiredService.value = "4"
        newForm.step3_4.howOften.value = res.item.num_required
        newForm.step3_4.timesPer.value = res.item.num_required_period
        newForm.step3_4.howMuch.value = res.item.cost_required
        newForm.step3_4.every.value = res.item.cost_required_period
        newForm.step3_4.cost.checked = res.item.unknown
        newForm.step3_4.files.value = res.documents
      }

      newForm.step4.goals.value = goals.map(goal => {
        const newGoal = {
          title: goal.title,
          description: goal.content,
          name: `goal${goal.id}`,
          id: goal.id,
          checked: false
        }

        res.goals.map(rGoal => {
          if (goal.id === rGoal.id) {
            newGoal.checked = true
          }

          return null
        })

        return newGoal
      })
    }

    this.setState({
      formIsHidden: false,
      currentId,
      form: newForm
    })
  }

  scrollToNextButton = () => {
    let offSet =
      this.form.getBoundingClientRect().bottom +
      window.pageYOffset -
      window.innerHeight
    const supportsNativeSmoothScroll =
      "scrollBehavior" in document.documentElement.style

    if (window.innerWidth <= 767) {
      offSet += 200
    } else {
      offSet += 100
    }

    if (supportsNativeSmoothScroll) {
      window.scrollTo({
        top: offSet,
        behavior: "smooth"
      })
    } else {
      window.scrollTo(0, offSet)
    }
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    const step = this.getActiveStepName()

    this.setState({
      form: {
        ...form,
        [step]: {
          ...form[step],
          [name]: {
            ...form[step][name],
            message: "",
            [field]: value
          }
        }
      }
    })

    if (name === "bestFitsRequiredService") {
      this.scrollToNextButton()
    }
  }

  removeItem = id => {
    const {
      onDeleteRequiredServices,
      store: { user, plan }
    } = this.props

    const deleteItem = () => {
      onDeleteRequiredServices(user.token, plan.id, id)
    }

    confirmAlert({
      title: "Are you sure?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            deleteItem()
          }
        },
        {
          label: "No"
        }
      ]
    })
  }

  addGoal = goal => {
    const { form, currentId, services } = this.state
    const {
      onSaveMyGoals,
      store: { user, plan }
    } = this.props

    const newGoals = [...plan.answers.myGoals.goal, goal]

    onSaveMyGoals(user.token, plan.id, newGoals).then(goals => {
      let currentService

      services.map(service => {
        if (service.id === currentId) {
          currentService = service
        }

        return null
      })

      const newFormGolas = goals.map(nGoal => {
        const newGoal = {
          title: nGoal.title,
          description: nGoal.content,
          name: `goal${nGoal.id}`,
          id: nGoal.id,
          checked: false
        }

        if (currentService) {
          currentService.goals.map(rGoal => {
            if (goal.id === rGoal.id) {
              newGoal.checked = true
            }

            return null
          })
        }

        return newGoal
      })

      this.setState({
        form: {
          ...form,
          step4: {
            ...form.step4,
            goals: {
              ...form.step4.goals,
              value: newFormGolas
            }
          }
        }
      })
    })
  }

  render() {
    const {
      formIsHidden,
      activeStep,
      form,
      isSubmitted,
      services,
      goals,
      currentId,
      requestSupportIsHidden
    } = this.state
    const {
      onBack,
      onNext,
      store: { plan, user, fileUploading }
    } = this.props

    const userIsGuardian = user.list_role.includes(configs.roles.Guardian)

    const oneOffPurchase = []
    const weeklyActivity = []
    const recurringActivity = []
    const recurringPurchase = []

    services.map(service => {
      if (service.item_type === "one_off_purchase") {
        oneOffPurchase.push(service)
      } else if (service.item_type === "weekly_activity") {
        weeklyActivity.push(service)
      } else if (service.item_type === "recurring_activity") {
        recurringActivity.push(service)
      } else if (service.item_type === "recurring_purchase") {
        recurringPurchase.push(service)
      }

      return null
    })

    return (
      <>
        <div className="pre-plan_header">
          <div className="pre-plan_title">
            Required Services
            {!formIsHidden && (
              <span className="pre-plan_title_question-counter">
                {" "}
                Question {activeStep}/4
              </span>
            )}
          </div>
          {formIsHidden && (
            <div className="pre-plan_description">
              The NDIS funds a range of supports and services to help
              participants pursue their goals, increase their independence and
              actively participate in the community. By following the prompts,
              provide as much detail as you can about these supports or services
              and link the goals (you can have multiple) that you will be able
              to achieve.
            </div>
          )}
        </div>

        {plan.loading ? (
          <Loader
            type="TailSpin"
            color="#0c4632"
            height={80}
            width={80}
            className="loader"
          />
        ) : (
          <>
            {formIsHidden && (
              <div className="row">
                <div className="col-xl-10 offset-xl-1">
                  {!!oneOffPurchase.length && (
                    <OneOffPurchasesCard
                      services={oneOffPurchase}
                      goals={goals}
                      onFormOpen={this.onFormOpen}
                      hideDelete={userIsGuardian}
                      removeItem={this.removeItem}
                    />
                  )}

                  {!!weeklyActivity.length && (
                    <DailyOrWeeklyServicesCard
                      services={weeklyActivity}
                      goals={goals}
                      onFormOpen={this.onFormOpen}
                      hideDelete={userIsGuardian}
                      removeItem={this.removeItem}
                    />
                  )}

                  {!!recurringActivity.length && (
                    <RecurringActivitiesCard
                      services={recurringActivity}
                      goals={goals}
                      onFormOpen={this.onFormOpen}
                      hideDelete={userIsGuardian}
                      removeItem={this.removeItem}
                    />
                  )}

                  {!!recurringPurchase.length && (
                    <RecurringPurchasesCard
                      services={recurringPurchase}
                      goals={goals}
                      onFormOpen={this.onFormOpen}
                      hideDelete={userIsGuardian}
                      removeItem={this.removeItem}
                    />
                  )}
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-xl-8 offset-xl-2">
                <Form
                  formRef={el => {
                    this.form = el
                  }}
                >
                  {formIsHidden ? (
                    <>
                      {!userIsGuardian && (
                        <Group>
                          <Repeater
                            text="Add A Required Service"
                            onClick={this.onFormOpen}
                          />
                        </Group>
                      )}

                      <Group className="form_btn-group form_group--padding-top-lg">
                        <Button
                          button={{ type: "button" }}
                          onClick={onBack}
                          className="btn--empty-secondary-light btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Back
                        </Button>

                        <Button
                          button={{ type: "button" }}
                          onClick={onNext}
                          className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Complete
                        </Button>
                      </Group>
                    </>
                  ) : (
                    <>
                      {(() => {
                        switch (+activeStep) {
                          case 1:
                            return (
                              <div className="pre-plan_step">
                                <div className="pre-plan_step_title">
                                  What Service Do You Need?
                                  <Tooltip>
                                    Tell us what service you need from the NDIS.
                                    Examples of required services could be a
                                    Cleaning Service, Mental Health Counselling,
                                    Physiotherapy or items or equipment you need
                                    to buy that help with your condition.
                                  </Tooltip>
                                </div>

                                <Group className="form_group--padding-top-lg">
                                  <Input
                                    onChange={this.onChange}
                                    isSubmitted={isSubmitted}
                                    field={form.step1.requiredService}
                                  />
                                </Group>
                              </div>
                            )
                          case 2:
                            return (
                              <div className="pre-plan_step">
                                <div className="pre-plan_step_title">
                                  Which Category Best Fits Your Required
                                  Service?
                                  <Tooltip>
                                    Please select the card that best matches
                                    your required service.
                                  </Tooltip>
                                </div>
                                <div className="pre-plan_step_description pre-plan_step_description--padding-top-lg">
                                  Your Required Service:{" "}
                                  {form.step1.requiredService.value}
                                </div>

                                <Group className="form_group--padding-top-lg">
                                  <RadioCard
                                    options={
                                      form.step2.bestFitsRequiredService.options
                                    }
                                    name={
                                      form.step2.bestFitsRequiredService.name
                                    }
                                    defaultValue={
                                      form.step2.bestFitsRequiredService.value
                                    }
                                    className="card--gray"
                                    classNameActive="card--green"
                                    onChange={this.onChange}
                                  />
                                </Group>
                              </div>
                            )
                          case 3:
                            return (() => {
                              switch (
                                form.step2.bestFitsRequiredService.value
                              ) {
                                case "1":
                                  return (
                                    <div className="pre-plan_step">
                                      <div className="pre-plan_step_title">
                                        How Much DO You Think Your One Off
                                        Purchase Will Cost?
                                        <Tooltip>
                                          NDIS asks for this information simply
                                          to get a good picture of your funding
                                          needs, they won’t push you to the
                                          cheapest option.
                                        </Tooltip>
                                      </div>
                                      <div className="pre-plan_step_description pre-plan_step_description--padding-top-lg">
                                        Your Required Service:{" "}
                                        {form.step1.requiredService.value}
                                      </div>

                                      <Group className="form_group--padding-top-lg">
                                        <div className="form_element-inline">
                                          <span className="form_element-inline_description">
                                            My Purchase Will Cost In Between
                                          </span>
                                          <Group
                                            style={{
                                              maxWidth: "230px"
                                            }}
                                          >
                                            <Input
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_1.lowGuess}
                                            />
                                          </Group>
                                          <span>And</span>
                                          <Group
                                            style={{
                                              maxWidth: "230px"
                                            }}
                                          >
                                            <Input
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_1.highGuess}
                                            />
                                          </Group>
                                        </div>
                                      </Group>

                                      <Group className="form_group--padding-top-lg">
                                        <Checkbox
                                          onChange={this.onChange}
                                          isSubmitted={isSubmitted}
                                          field={form.step3_1.cost}
                                        />
                                      </Group>

                                      {!userIsGuardian && (
                                        <Group className="form_group--padding-top-lg">
                                          <File
                                            onChange={this.onChange}
                                            isSubmitted={isSubmitted}
                                            hideUploadBtn={userIsGuardian}
                                            hideDelete={userIsGuardian}
                                            field={form.step3_1.files}
                                          />
                                        </Group>
                                      )}
                                    </div>
                                  )
                                case "2":
                                  return (
                                    <div className="pre-plan_step">
                                      <div className="pre-plan_step_title">
                                        What Days Do You Need Your Service?
                                        <Tooltip>
                                          Lorem ipsum dolor sit amet,
                                          consectetur adipiscing elit.
                                          Suspendisse in viverra justo, et
                                          ultricies orci.
                                        </Tooltip>
                                      </div>
                                      <div className="pre-plan_step_description pre-plan_step_description--padding-top-lg">
                                        Your Required Service:{" "}
                                        {form.step1.requiredService.value}
                                      </div>

                                      <DayPicker
                                        defalutDays={
                                          form.step3_2.daysService.value
                                        }
                                        isSubmitted={isSubmitted}
                                        onChange={this.onChange}
                                        fieldName={
                                          form.step3_2.daysService.name
                                        }
                                      >
                                        <div className="pre-plan_step_title">
                                          What Times Do You Want This Service To
                                          Occur?
                                        </div>
                                      </DayPicker>
                                    </div>
                                  )
                                case "3":
                                  return (
                                    <div className="pre-plan_step">
                                      <div className="pre-plan_step_title">
                                        How Often Will You Need To Make This
                                        Purchase
                                        <Tooltip>
                                          Lorem ipsum dolor sit amet,
                                          consectetur adipiscing elit.
                                          Suspendisse in viverra justo, et
                                          ultricies orci.
                                        </Tooltip>
                                      </div>
                                      <div className="pre-plan_step_description pre-plan_step_description--padding-top-lg">
                                        Your Required Service:{" "}
                                        {form.step1.requiredService.value}
                                      </div>

                                      <Group className="form_group--padding-top-lg">
                                        <div className="form_element-inline">
                                          <span className="form_element-inline_description">
                                            How Often Do You Use The Item
                                          </span>
                                          <Group
                                            style={{
                                              maxWidth: "90px"
                                            }}
                                          >
                                            <Input
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_3.howOften}
                                            />
                                          </Group>
                                          <span>Times Per</span>
                                          <Group
                                            style={{
                                              maxWidth: "340px"
                                            }}
                                          >
                                            <Select
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_3.timesPer}
                                            />
                                          </Group>
                                        </div>
                                      </Group>

                                      <Group className="form_group--padding-top-lg">
                                        <div className="form_element-inline">
                                          <span className="form_element-inline_description">
                                            How Much Do You Think You Will Spend
                                            On It
                                          </span>
                                          <Group
                                            style={{
                                              maxWidth: "120px"
                                            }}
                                          >
                                            <Input
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_3.howMuch}
                                            />
                                          </Group>
                                          <span>Every</span>
                                          <Group
                                            style={{
                                              maxWidth: "270px"
                                            }}
                                          >
                                            <Select
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_3.every}
                                            />
                                          </Group>
                                        </div>
                                      </Group>

                                      <Group className="form_group--padding-top-lg">
                                        <Checkbox
                                          onChange={this.onChange}
                                          isSubmitted={isSubmitted}
                                          field={form.step3_3.cost}
                                        />
                                      </Group>

                                      {!userIsGuardian && (
                                        <Group className="form_group--padding-top-lg">
                                          <File
                                            onChange={this.onChange}
                                            isSubmitted={isSubmitted}
                                            field={form.step3_3.files}
                                          />
                                        </Group>
                                      )}
                                    </div>
                                  )
                                case "4":
                                  return (
                                    <div className="pre-plan_step">
                                      <div className="pre-plan_step_title">
                                        How Often Will You Need To Undertake
                                        This Activity
                                        <Tooltip>
                                          Lorem ipsum dolor sit amet,
                                          consectetur adipiscing elit.
                                          Suspendisse in viverra justo, et
                                          ultricies orci.
                                        </Tooltip>
                                      </div>
                                      <div className="pre-plan_step_description pre-plan_step_description--padding-top-lg">
                                        Your Required Service:{" "}
                                        {form.step1.requiredService.value}
                                      </div>

                                      <Group className="form_group--padding-top-lg">
                                        <div className="form_element-inline">
                                          <span className="form_element-inline_description">
                                            How Often Do You Need This Service
                                          </span>
                                          <Group
                                            style={{
                                              maxWidth: "90px"
                                            }}
                                          >
                                            <Input
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_4.howOften}
                                            />
                                          </Group>
                                          <span>Times Per</span>
                                          <Group
                                            style={{
                                              maxWidth: "340px"
                                            }}
                                          >
                                            <Select
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_4.timesPer}
                                            />
                                          </Group>
                                        </div>
                                      </Group>

                                      <Group className="form_group--padding-top-lg">
                                        <div className="form_element-inline">
                                          <span className="form_element-inline_description">
                                            How Much Do You Think You Will Spend
                                            On It
                                          </span>
                                          <Group
                                            style={{
                                              maxWidth: "120px"
                                            }}
                                          >
                                            <Input
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_4.howMuch}
                                            />
                                          </Group>
                                          <span>Every</span>
                                          <Group
                                            style={{
                                              maxWidth: "270px"
                                            }}
                                          >
                                            <Select
                                              onChange={this.onChange}
                                              isSubmitted={isSubmitted}
                                              field={form.step3_4.every}
                                            />
                                          </Group>
                                        </div>
                                      </Group>

                                      <Group className="form_group--padding-top-lg">
                                        <Checkbox
                                          onChange={this.onChange}
                                          isSubmitted={isSubmitted}
                                          field={form.step3_4.cost}
                                        />
                                      </Group>

                                      {!userIsGuardian && (
                                        <Group className="form_group--padding-top-lg">
                                          <File
                                            onChange={this.onChange}
                                            isSubmitted={isSubmitted}
                                            field={form.step3_4.files}
                                          />
                                        </Group>
                                      )}
                                    </div>
                                  )
                                default:
                                  return null
                              }
                            })()
                          case 4:
                            return (
                              <div className="pre-plan_step">
                                <div className="pre-plan_step_title">
                                  Which Goal Will This Service Help You Achieve?
                                  <Tooltip>
                                    Pick one or more goals you will achieve by
                                    having this required service.
                                  </Tooltip>
                                </div>
                                <div className="pre-plan_step_description pre-plan_step_description--padding-top-lg">
                                  Your Required Service:{" "}
                                  {form.step1.requiredService.value}
                                </div>

                                <Group className="form_group--padding-top-lg">
                                  <CheckboxCards
                                    list={form.step4.goals.value}
                                    name={form.step4.goals.name}
                                    className="info-card--gray"
                                    classNameActive="info-card--green"
                                    hideAddGoal={userIsGuardian}
                                    addGoal={this.addGoal}
                                    onChange={this.onChange}
                                  />
                                </Group>
                              </div>
                            )
                          default:
                            return null
                        }
                      })()}

                      <Group className="form_btn-group form_group--padding-top-lg">
                        <Button
                          button={{ type: "button", disabled: fileUploading }}
                          onClick={this.handleBack}
                          className="btn--empty-secondary-light btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Back
                        </Button>

                        {activeStep < 4 && (
                          <Button
                            button={{ type: "button", disabled: fileUploading }}
                            onClick={this.handleNext}
                            className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                          >
                            Next
                          </Button>
                        )}

                        {activeStep === 4 && (
                          <Button
                            button={{ type: "button" }}
                            onClick={this.handleNext}
                            className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                          >
                            Complete My Service
                          </Button>
                        )}

                        {currentId !== null && (
                          <Button
                            button={{ type: "button" }}
                            onClick={this.requestSupportToggle}
                            className={`
                            btn--cancel-light 
                            btn--request-support 
                            btn--width-md 
                            btn--height-sm 
                            btn--font-size-md 
                            ${
                              !requestSupportIsHidden
                                ? "btn--request-support-active"
                                : ""
                            }
                            `}
                          >
                            Request Support
                          </Button>
                        )}
                      </Group>
                    </>
                  )}
                </Form>

                {plan.answers.supportTeam && currentId && (
                  <RequestSupport
                    guardians={plan.answers.supportTeam}
                    planSection="RS"
                    planSubsection={currentId}
                    isHidden={requestSupportIsHidden}
                    onToggle={this.requestSupportToggle}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </>
    )
  }
}

AddService.propTypes = {
  onBack: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired,
  onDeleteRequiredServices: propTypes.func.isRequired,
  onSaveRequiredServices: propTypes.func.isRequired,
  onSaveMyGoals: propTypes.func.isRequired,
  scrollToNav: propTypes.func.isRequired,
  id: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }),
    plan: propTypes.shape({
      loading: propTypes.bool,
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      answers: propTypes.shape({
        requiredServices: propTypes.arrayOf(propTypes.shape({})),
        supportTeam: propTypes.arrayOf(propTypes.shape({})),
        myGoals: propTypes.shape({
          goal: propTypes.arrayOf(propTypes.shape({}))
        })
      })
    }),
    fileUploading: propTypes.bool
  }).isRequired,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer,
    fileUploading: PlansReducer.fileUploading
  }
})

const mapDispatchToProps = dispatch => ({
  onSaveRequiredServices: (token, planId, service, type, serviceId) =>
    dispatch(saveRequiredServices(token, planId, service, type, serviceId)),
  onDeleteRequiredServices: (token, planId, serviceId) =>
    dispatch(deleteRequiredServices(token, planId, serviceId)),
  onSaveMyGoals: (token, planId, goals) =>
    dispatch(saveMyGoals(token, planId, goals))
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddService)
)
